document.addEventListener('DOMContentLoaded', function(){


  Livewire.on('send-mail',function(send_mail_id, token){

    fetch('/api-mail/send-mail', {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': token
      },
      method: 'POST',
      body: JSON.stringify({
        send_mail_id: send_mail_id,
      }),
    });
    
  });

});